module.exports = __webpack_public_path__ + "img/express-gray.fafe9b01.svg";